import { createUseStyles } from "react-jss";

export const RequestDetailContainerStyle = createUseStyles((theme: any) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: "var(--gaps-sizes-base)",
        padding:10
    },
    sectionTitle: {
        color: "var(--text-color-purple)",
        fontWeight: "var(--font-weigth-bold)",
        fontSize: "var(--font-size-md)",
        padding: "var(--padding-sizes-xs)",
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: 5,
        borderBottom: "3px solid var(--color-default-text)",
        padding: "var(--padding-sizes-xs)",
        gap:20
    },
    dataContent: {
        display: "flex",
        gap: "var(--gaps-sizes-xs)",
        flexDirection: "column",
        justifyContent: "space-between",
    },

    sectionDataContent: {
        display: "flex",
        flexDirection: "column",
        fontSize:"var(--font-size-base)",
        background: "var(--color-background-text)",
        padding: "7px",
        gap: "var(--gaps-sizes-xs)",
    },
    image: {
        width: "auto",
        maxWidth: "2.7rem",
    },
    calendarImage: {
        width: "auto",
        maxWidth: "1.5rem",
    },
    headerSection: {
        display: "flex",
        gap: "var(--gaps-sizes-sm)",
        alignContent: "center",
        alignItems: "center",
    },
    stateDescription: {
        paddingLeft: "5px",
    },
    icon: {
        cursor: "pointer",
    },
    date:{
        fontSize:"0.9rem"
    }
}));
